var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeaderboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "leaderboard",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_343",
    "data-name": "Path 343",
    d: "M15,1.5H13.25V1a1,1,0,0,0-1-1H3.75a1,1,0,0,0-1,1v.5H1a1,1,0,0,0-1,1v2A2.75,2.75,0,0,0,2.75,7.25h.024A5.249,5.249,0,0,0,7.25,11.941V14H5.5a1,1,0,0,0-1,1v.75a.25.25,0,0,0,.25.25h6.5a.25.25,0,0,0,.25-.25V15a1,1,0,0,0-1-1H8.75V11.941A5.249,5.249,0,0,0,13.226,7.25h.024A2.75,2.75,0,0,0,16,4.5v-2A1,1,0,0,0,15,1.5ZM1.5,4.5V3H2.75V5.75A1.25,1.25,0,0,1,1.5,4.5Zm8.428.762-.786.807L9.328,7.21a.25.25,0,0,1-.368.259L8,6.938l-.96.531a.25.25,0,0,1-.368-.259l.186-1.141-.786-.807a.25.25,0,0,1,.141-.422L7.29,4.675l.484-1.031a.25.25,0,0,1,.453,0L8.71,4.675l1.077.165a.25.25,0,0,1,.141.422ZM14.5,4.5a1.25,1.25,0,0,1-1.25,1.25V3H14.5Z",
    fill: "#37e0eb"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_344",
    "data-name": "Path 344",
    d: "M28.269,17.876l-.243-.518-.243.518a.193.193,0,0,1-.146.109l-.563.086.414.424a.193.193,0,0,1,.052.166l-.1.586.488-.27a.193.193,0,0,1,.187,0l.488.27-.1-.586a.194.194,0,0,1,.052-.166l.414-.424-.563-.086A.193.193,0,0,1,28.269,17.876Z",
    transform: "translate(-20.027 -12.841)",
    fill: "#37e0eb"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaderboard);
export default __webpack_public_path__ + "static/media/leaderboard.d97ca5e20f48ba93087d72896945e76f.svg";
export { ForwardRef as ReactComponent };